import { useEffect, useContext } from 'react';
import { Avatar, Box, Grid, Typography, IconButton, Stack, CircularProgress } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import PlaceIcon from "@mui/icons-material/Place";
import ExpandIcon from "../../../../../../../../assets/images/icons/expand_icon.png";
import { rqx } from '../../../../../../../../core/request/API';
import { env } from '../../../../../../../../core/Env';
import { ToolContext } from '../../../../../../../../core/context/ToolContext';

export const View = ({ rndrPrice, td }) => {
    const { website_state, realproperty_state } = useContext(ToolContext);
    const { view, viewLoader } = website_state;
    const { types } = realproperty_state;
    const { details, attachments } = view.data;
    const viewId = new URLSearchParams(window.location.search).get('view')
    const readView = async () => {
        viewLoader.set(true)
        const res_details = await rqx.get(`<<shp>>/${env()}/realproperty/view`, { id: window.atob(viewId) });
        const res_attachments = await rqx.get(`<<shp>>/${env()}/realproperty/attachment`, { listing_id: window.atob(viewId) });
        if (res_details && res_attachments ) {
            view.set((p) => ({
                ...p,
                    details: res_details,
                    attachments: res_attachments,
            }));
        }
        if (types.data.indoorFacilities.length === 0 && types.data.outdoorFacilities.length === 0) {
            const res_fclts = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "facilities" });
            if (res_fclts) {
                types.set((p) => ({
                    ...p,
                    indoorFacilities: res_fclts?.filter(v => v.type === 1).sort((a, b) => a.name.localeCompare(b.name)),
                    outdoorFacilities: res_fclts?.filter(v => v.type === 2).sort((a, b) => a.name.localeCompare(b.name)),
                }));
            }
        }
        viewLoader.set(false);
    }

    useEffect(() => {
        readView();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (details.length > 0) {
            view.set({
                ...view.data,
                    details: {
                        ...view.data.details[0],
                        listing_information: JSON.parse(details[0]?.listing_information),
                        indoor_facilities: JSON.parse(details[0]?.indoor_facilities),
                        outdoor_facilities: JSON.parse(details[0]?.outdoor_facilities),
                        price: JSON.parse(details[0]?.price),
                },
            });
        }
        // eslint-disable-next-line
    }, [details]);

    const dsplyFclts = (f, t) => {
        return f?.map((v, k) => (
            <Grid key={k} item xs={6}>
                <Typography lineHeight="15px" sx={{ fontSize: "0.75rem", fontWeight: "400" }}>
                    • 
                    {  
                        f?.every(v => typeof v === 'object') ? 
                            v.name 
                        :   
                            t?.find(item => item.id === v)?.name
                    }
                </Typography>
            </Grid>
        ))
    }

	return (
        <Box width="100%" height="100%">
            {attachments.length === 0 || viewLoader.data ? 
                (
                    <Box display="flex" justifyContent="center" mt="10rem">
                        <CircularProgress sx={{ color: td.top.bg_color}}/>
                    </Box>
                ) 
            : 
                (
                    <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center" gap={2}>
                        <Box width="100%" height="100%" p="1rem" className="overflowY">
                            <Box width="100%">
                            <Box fontSize="0.75rem" color="#19191A" fontWeight={600} lineHeight="18px" mb="1rem" >Top Listings</Box>
                                <Box height="198px">
                                    <Box
                                        component="img"
                                        src={attachments[0].link}
                                        alt="Cover Photo"
                                        sx={{ height: "100%", width: "100%", objectFit: 'cover', borderRadius: "12px"}}
                                    />
                                </Box>
                                <Box sx={{ position: "relative", my: "0.5rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Stack sx={{ overflowX: "hidden", mx: "1.5rem" }}>
                                        <Box sx={{ display: "flex", columnGap: "0.5rem", justifyContent: "flex-start", alignItems: "center" }}>
                                            {attachments &&
                                            Object.values(attachments).map((p, k) => (
                                                <Avatar key={k} src={p.link} alt={p.name}
                                                    sx={{ width: "4rem", height: "4rem", borderRadius: "10px" }}
                                                />
                                            ))}
                                        </Box>
                                    </Stack>
                                    <IconButton sx={{ cursor: "default", position: "absolute", top: "50%", left: 0, transform: "translateY(-50%)", p: "0" }}>
                                        <ArrowBackIos sx={{ fontSize: "1.4rem", fontWeight: "bold" }} />
                                    </IconButton>
                                    <IconButton sx={{ cursor: "default", position: "absolute", top: "50%", right: "-0.313rem", transform: "translateY(-50%)", p: "0" }}>
                                        <ArrowForwardIos sx={{ fontSize: "1.4rem", fontWeight: "bold" }} />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Box width="100%" mt={2}>
                                <Box textAlign="center" fontSize="1.25rem" fontWeight={600} lineHeight="30px" mb="7px"> 
                                    {details.name}
                                </Box>
                                <Box display="flex" alignItems="center" mt="0.6rem">
                                    <PlaceIcon fontSize="1rem" sx={{mr: "0.5rem"}}/>
                                    <Box fontSize="0.625rem" lineHeight="18px" fontWeight={500} sx={{ textTransform: 'uppercase' }}>
                                        {details.city_name}, {details.province_name}
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" mt="4px">
                                    <Avatar src={ExpandIcon} sx={{ height: "13px", width: "13px" }}/>
                                    <Box fontSize="0.625rem" lineHeight="15px" fontWeight={500} ml="10px">
                                        {details.listing_information?.floor_area} m <sup>2</sup>
                                    </Box>
                                </Box>
                                <Box> { details?.price && rndrPrice(details.price, "view") } </Box>
                                <Box mt="1rem">
                                    <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Overview</Typography>
                                    <Typography fontSize="0.75rem" lineHeight="15px" fontWeight={500} dangerouslySetInnerHTML={{ __html: details.description }}/>
                                </Box>
                                <Box mt="0.7rem">
                                    <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Indoor Activities</Typography>
                                    <Grid container sx={{ px: "1rem" }}>
                                        {/* {details.indoor_facilities?.map((v, k) => (
                                            <Grid key={k} item xs={6} >
                                                <Typography lineHeight="15px" sx={{ fontSize: "0.75rem", fontWeight: "400" }}>• {v.name}</Typography>
                                            </Grid>
                                        ))} */}
                                        {dsplyFclts(details.indoor_facilities,  types.data.indoorFacilities)}
                                    </Grid>
                                </Box>
                                <Box mt="0.7rem">
                                    <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Outdoor Activities</Typography>
                                    <Grid container sx={{ px: "1rem" }}>
                                        {/* {details.outdoor_facilities?.map((v, k) => (
                                            <Grid key={k} item xs={6} >
                                                <Typography lineHeight="15px" sx={{ fontSize: "0.75rem", fontWeight: "400" }}>• {v.name}</Typography>
                                            </Grid>
                                        ))} */}
                                        {dsplyFclts(details.outdoor_facilities,  types.data.outdoorFacilities)}
                                    </Grid>
                                </Box>
                                <Box mt="0.6rem" mb="8rem">
                                    <Typography fontSize="0.875rem" lineHeight="18px" fontWeight={600} color="#19191A" mb="8px">Contact Details</Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", ml: "1rem" }}>
                                        <Avatar />
                                        <Box sx={{ ml: "0.8rem" }}>
                                            <Typography sx={{ fontSize: "0.8rem" }}>{details.first_name} {details.last_name}</Typography>
                                            <Typography sx={{ fontSize: "0.8rem", mt: "8px" }}>{details.email} </Typography>
                                            <Typography sx={{ fontSize: "0.8rem", mt: "8px" }}>{details.phone_number}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box> 
                    </Box>
                )
            }
        </Box>
	)
}
